import Vue from 'vue'
import Vuex from 'vuex'
// 挂载vuex
Vue.use(Vuex)

// 创建vuex对象并向外暴露
export default new Vuex.Store({
  // 全局属性变量
  state: {
    count: 0,
  },
  // 全局同步方法, 调用方法,this.$store.commit("xxx")
  mutations: {
    increment (state,pls) {
      state.count+=pls
    }
  },
  // 异步方法 调用方法,this.$store.dispatch("xxx")
  actions: {
      num({commit},pad){
        commit('increment', pad)

      }
  },
  // Vuex属性计算,在视图里面当变量使用
  getters: {
  },
  // 模块化注册
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js